import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import * as UserAction from '../../../actions/User.actions';
import { getExistence } from '../../../api/User.api';
import '../../../styles/components/options/popups/edit_popup_content.scss';
import { INDICATE } from '../../../constants/Constant';
import { NAME_FORM } from '../../../constants/FormNames';
import { ValidationTypes } from '../../../enums/ValidationTypes';
import Button from '../../Button';
import TextInput from '../../TextInput';

const EditName = ({
	formData,
	type = 'text',
	user,
	name,
	updateProfile,
	onHanleSuccess,
	auth,
}) => {
	const [usernameValid, setUsernameValid] = useState(false);
	const [unameIcon, setUnameIcon] = useState<any>();

	useEffect(() => {
		if (formData.userName === auth.user) return;
		setUnameIcon(INDICATE.loading);
		setUsernameValid(false);
		const timeOutId = setTimeout(() => {
			name === 'userName' && formData.userName.trim() && validateUserName();
		}, 2000);
		return () => clearTimeout(timeOutId);
	}, [formData.userName]);

	const handleSave = () => {
		updateProfile(
			{
				[name]: formData[name],
			},
			data => {
				onHanleSuccess({ data, userName: formData.userName });
			},

			err => {
				console.log(err);
			}
		);
	};

	const validateUserName = async () => {
		const validity: any = await getExistence({
			name: formData.userName?.toLowerCase(),
		});
		setUnameIcon(validity.exists ? null : INDICATE.valid);
		setUsernameValid(!validity.exists);
	};

	return (
		<div className='edit_name_container'>
			<div className='input-wrapper'>
				<div className='input-container'>
					<TextInput
						type={type}
						id={name}
						placeholder={name}
						form={NAME_FORM}
						value={formData[name] ? formData[name] : user[name]}
						name={name}
						rightSideIcon={
							name === 'userName' && formData.userName !== auth.userName
								? unameIcon?.icon
								: null
						}
						validations={[ValidationTypes.required]}
					/>
				</div>
			</div>
			<div className='button-wrapper'>
				<Button
					active
					diactivated={name === 'userName' && !usernameValid}
					className='save-button'
					labal='Save'
					onClickEvent={() => handleSave()}
				></Button>
			</div>
		</div>
	);
};

const mapStateToProps = ({ forms, user, auth }) => ({
	formData: forms?.[NAME_FORM]?.values || {},
	user,
	auth,
});

const mapDispatchToProps = {
	updateProfile: UserAction.updateProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditName);
